import { Box, Stack } from '@mui/material';
import { miniButtonDockScrollBottomPad } from '@focuslee/shared-mini-app';
import { FC } from 'react';
import { AchievementCategoriesSkeleton } from './AchievementCategoriesSkeleton';
import { LatestAchievementsSkeleton } from './LatestAchievementsSkeleton';

export const AchievementPageSkeleton: FC = () => {
    return (
        <Stack sx={{ position: 'relative', height: '100%', overflow: 'hidden', bgcolor: 'var(--tg-theme-secondary-bg-color)' }}>
            <Box
                sx={{
                    position: 'absolute',
                    inset: 0,
                    overflow: 'hidden',
                    paddingTop:
                        'calc(var(--tg-viewport-content-safe-area-inset-top, 0px) + var(--tg-viewport-safe-area-inset-top, 0px) + 12px)',
                    paddingLeft: '16px',
                    paddingRight: '16px',
                    paddingBottom: miniButtonDockScrollBottomPad,
                }}
            >
                <Stack gap={2}>
                    <LatestAchievementsSkeleton count={3} />
                    <AchievementCategoriesSkeleton count={5} />
                </Stack>
            </Box>
        </Stack>
    );
};
